import { render } from "./layout-sidebar.vue?vue&type=template&id=4dff31a2&scoped=true"
import script from "./layout-sidebar.vue?vue&type=script&lang=js"
export * from "./layout-sidebar.vue?vue&type=script&lang=js"

import "./layout-sidebar.vue?vue&type=style&index=0&id=4dff31a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dff31a2"]])

export default __exports__